/* global gtag_report_conversion */
import React from "react";
import { FiPhone } from "react-icons/fi";
import "../styles/common.css";
import "../styles/StoriesCarousel.css"; // reusing .nav-button styles

export default function StoriesCarousel() {
  const phoneHref = "tel:+36301234567";

  const stories = [
    {
      id: 1,
      title: "Reggel nem indul az autó",
      desc: "Hidegben vagy hosszabb állás után az akkumulátor könnyen lemerülhet. Hívj minket, és percek alatt úton leszel.",
      img: "/images/story1.webp",
      alt: "Autó reggeli indulás előtt, lemerült akkumulátorral a ház előtt",
    },
    {
      id: 2,
      title: "Bevásárlóközpont parkolója",
      desc: "Véletlenül égve maradtak a lámpák? Kimegyünk a parkolóba és szakszerűen bebikázzuk a járműved.",
      img: "/images/story2.webp",
      alt: "Bevásárlóközpont parkolója, segítségre váró autó",
    },
    {
      id: 3,
      title: "Akkumulátor állapotfelmérés",
      desc: "A helyszínen gyorsan és szakszerűen felmérjük az akkumulátor állapotát, így pontos képet kapsz arról, hogy indítási probléma vagy csereigény áll-e fenn.",
      img: "/images/story3.webp",
      alt: "Szerelő akkumulátor állapotát ellenőrzi egy autó motorterében",
    },
  ];

  return (
    <section id="mikor-kell-bikazas" className="stories-section py-5">
      <div className="container">
        {/* Header + description */}
        <div className="row mb-4">
          <div className="col-lg-10 mx-auto text-center">
            <h2 className="fw-bold mb-2">
              Mikor lehet szükséged akkkumulátor bikázásra?
            </h2>
            <div className="double-divider my-1 mb-3"></div>
            <p className="lead text-muted mb-0">
              Három tipikus helyzet, amikor gyorsan, biztonságosan és
              garanciával segítünk.
            </p>
          </div>
        </div>

        {/* Carousel */}
        <div
          id="bikazasCarousel"
          className="carousel slide"
          data-bs-ride="carousel"
          data-bs-touch="true"
          data-bs-interval="6000"
          data-bs-wrap="true"
        >
          {/* indicators */}
          <div className="carousel-indicators">
            {stories.map((s, i) => (
              <button
                key={s.id}
                type="button"
                data-bs-target="#bikazasCarousel"
                data-bs-slide-to={i}
                className={i === 0 ? "active" : ""}
                aria-current={i === 0 ? "true" : undefined}
                aria-label={`${s.title} dia`}
              />
            ))}
          </div>

          <div className="carousel-inner rounded-4 shadow">
            {stories.map((s, i) => (
              <div
                className={`carousel-item ${i === 0 ? "active" : ""}`}
                key={s.id}
                data-bs-interval="6000"
              >
                <img
                  src={s.img}
                  className="d-block w-100 object-fit-cover story-image"
                  alt={s.alt}
                />

                <div className="story-card bg-caption-under mt-0 pb-5">
                  <h5 className="fw-semibold mb-2">{s.title}</h5>
                  <p className="mb-3 mb-md-4">{s.desc}</p>
                  <a
                    href="tel:+36206282000"
                    className="call-btn px-4 py-3 fs-4 d-inline-flex align-items-center"
                    onClick={(e) => {
                      try {
                        if (typeof gtag_report_conversion === "function") {
                          gtag_report_conversion("tel:+36206282000");
                        }
                      } catch (err) {
                        console.error("gtag_report_conversion error:", err);
                      }
                    }}
                  >
                    <FiPhone className="me-2" />
                    +36 20 628 2000
                  </a>
                </div>
              </div>
            ))}
          </div>

          {/* Controls */}
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#bikazasCarousel"
            data-bs-slide="prev"
          >
            <span
              className="carousel-control-prev-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Előző</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#bikazasCarousel"
            data-bs-slide="next"
          >
            <span
              className="carousel-control-next-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Következő</span>
          </button>
        </div>
      </div>
    </section>
  );
}
